import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class UnAuthenticatedUserService {
    constructor() {}
    user: any;
}
